import Link from "next/link";

type LogoProps = {
  color?: "white" | "orange";
};

const Logo = ({ color = "white" }: LogoProps) => {
  return (
    <Link href="/" passHref>
      <a>
        <img
          src={`${
            color === "white"
              ? "/img/brand/valmeego-logo-white.svg"
              : "/img/brand/valmeego-logo.svg"
          }`}
          width="180"
          height="70"
          alt="Valmeego Logo"
          title="Valmeego - Locally and beyond"
          style={{ display: "block" }}
        />
      </a>
    </Link>
  );
};

export default Logo;
